import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./legislations.scss";
import axios from "../../axios";
import Search from "../search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

const Legislations = () => {
  const [legislationdata, setlegislationdata] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 5;
  const productsPerList = 50;
  const pagesVisited = pageNumber * productsPerPage;
  let displaylegislationdata = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    // console.log(selected);
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("legislations/all")
      .then((res) => {
        setlegislationdata(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  }, []);
  // console.log("EGISLATIONS", legislationdata);
  return (
    <div className="legislation p-5 text-left">
      <div className="page-title ">
        <h1>Legislations Management</h1>
      </div>
      <div className="row ml-n4 search">
        <div className="col-md-9 col-sm-12">
          <Search
            data={legislationdata}
            title="legislation"
            filtered={setFiltered}
            setPageNumber={setPageNumber}
          />
        </div>
        <div className="col-md-3 col-sm-12 ">
          <Link to="/legislations/add" className="myButton">
            Add New Legislation
          </Link>
        </div>
      </div>
      {/* <div className="row">
        <Link to="/legislations/add" className="myButton">
          Add New Legislation
        </Link>
      </div> */}
      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row ">
                <div className="col-1">ID</div>
                <div className="col-4">Legislation Name</div>
                <div className="col-2">Status:</div>
                <div className="col-1">ALB</div>
                <div className="col-1">SRB</div>
                <div className="col-1">ENG</div>
                {/* <div className='col-1'>{filtered.def_lang} </div> */}

                <div className="col-1 hideme"> </div>
                {/* <div className='col-1 hideme'> </div> */}
              </div>
            </div>{" "}
            {
              (displaylegislationdata = filtered
                ?.slice(pagesVisited, pagesVisited + productsPerPage)
                ?.map((filtered) => {
                  return (
                    <div className="listimi showme" key={filtered.id}>
                      <div className="row ">
                        <div className="col-1">{filtered.id} </div>
                        <div className="col-4">
                          {filtered.name_al.slice(0, 33)}
                          {" ..."}
                        </div>
                        <div className="col-2">{filtered.lawstatus} </div>

                        <div className="col-1">
                          {filtered.desc_al === null ||
                            filtered.desc_al === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        <div className="col-1">
                          {filtered.desc_sr === null ||
                            filtered.desc_sr === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        <div className="col-1">
                          {filtered.desc_en === null ||
                            filtered.desc_en === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}{" "}
                        </div>

                        {/* <div className='col-1'>{filtered.def_lang} </div> */}
                        <div className="col-1 delete">
                          <Link
                            className={"fa fa-trash"}
                            to={"/legislations/delete/" + filtered.id}
                          ></Link>
                        </div>
                        <div className="col-1 edit">
                          <Link
                            className={"fa fa-edit"}
                            to={"/legislations/edit/" + filtered.id}
                          ></Link>
                        </div>
                      </div>
                    </div>
                  );
                }))
            }
          </>
        )}
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {legislationdata.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Legislations;
